'use strict';

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function () {

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    var paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach(function (e) {
        return e.innerHTML.trim() === '' && e.parentNode.removeChild(e);
    });

    // Update Slick dots inside each slide
    var slick_activeClass = 'slick-active',
        slick_ariaAttribute = 'aria-hidden';
    $('.js-dotsInSlide').on('init', function () {
        $('.slick-dots li:first-of-type').addClass(slick_activeClass).attr(slick_ariaAttribute, false);
    }).on('afterChange', function (e, slick, currentSlide) {
        $.each(slick.$dots, function (i, el) {
            $(el).find('li').eq(currentSlide).addClass(slick_activeClass).find('button');
        });
    });

    //Open Navigation
    $('#menu-btn').click(function (event) {
        $('#menu-btn').toggleClass('btn-active');
        $('#primary-nav').toggleClass('nav-visible');
        $('body').toggleClass('overflow-hidden');
    });

    $('.sym-slides').slick();

    // View All Amenities
    // document.querySelectorAll('.js-viewAll_li > .sym-inline-list').forEach((list,i) => {
    //     let list_limit = 6;
    //     if (list.children.length > list_limit) {
    //         // 1. Hide items
    //         Array.from(list.children).slice(list_limit).forEach((item) => {
    //             item.classList.add('hidden');
    //         });

    //         // 2. Add toggle
    //         // list.insertAdjacentHTML('afterend', `<span class="toggle-viewAll_li" id="js-toggle-viewAll_li${i}">View all</span>`);

    //         // 3. Show items on click
    //         // let toggleItem = document.getElementById(`js-toggle-viewAll_li${i}`);
    //         // console.log(toggleItem);
    //         // toggleItem.addEventListener('click', () => {
    //         //     toggleItem.classList.add('hidden');
    //         //     Array.from(list.children).forEach((item) => {
    //         //         item.classList.remove('hidden');
    //         //     });
    //         // });

    //         // Show fancybox trigger
    //         list.parentNode.getElementsByClassName('fancybox')[0].classList.add('visible');
    //     }
    // });
})();